export default { commit: "71b85ad", logMessage: "71b85ad Gallery load issue removing loader" };
